import { trapFocus } from '@shopify/theme-a11y'

const modalBlocker = document.querySelector('.modal-blocker')

// Helpers for Configurator modal events
const configurator = document.getElementById('configurator')
const configuratorOpenModalEvent = 'configuratorOpenModal'

let focusFrom;

const openModal = (modalName) => {
    const targetModal = document.querySelector(`[data-modal="${modalName}"]`)
    document.body.classList.add('modal-is-open')

    if (targetModal) {
        targetModal.dataset.open = 'true'
        trapFocus(targetModal)
        setTimeout(() => targetModal.querySelector('[data-close-modal]').focus(), 100)
        document.addEventListener('keyup', event => {
            if (event.key === 'Escape') closeModals()
        })
    }
}

const closeModals = () => {
    document.querySelectorAll('[data-modal]').forEach(modal => {
        delete modal.dataset.open
        document.body.classList.remove('modal-is-open')
    })
    if (focusFrom) {
        setTimeout(() => focusFrom.focus(), 300)
    }
}

function handleOpenModal(event) {
    let targetElement;
    let modalId;

    if (event.type === configuratorOpenModalEvent) {
        // Extract custom event details
        targetElement = event.detail.element;
        modalId = event.detail.modalId;
    } else {
        // Regular click event
        targetElement = event.currentTarget;
        modalId = targetElement.dataset.openModal;
    }

    focusFrom = targetElement;
    openModal(modalId);
}

// Function to initialize/reinitialize modal triggers
const initModalTriggers = () => {
    document.querySelectorAll('[data-open-modal]').forEach(toggle => {
        // Remove existing listener if any to prevent duplicates
        toggle.removeEventListener('click', handleOpenModal)
        // Add listener
        toggle.addEventListener('click', handleOpenModal)
    })

    document.querySelectorAll('[data-close-modal]').forEach(toggle => {
        // Remove existing listener if any to prevent duplicates
        toggle.removeEventListener('click', closeModals)
        // Add listener
        toggle.addEventListener('click', closeModals)
    })
}

if (modalBlocker) {
    modalBlocker.addEventListener('click', closeModals)
}

// Initial setup
initModalTriggers()

// Listen for the Configurator custom event
if (configurator) {
    window.addEventListener(configuratorOpenModalEvent, handleOpenModal)
}

export { openModal, closeModals, initModalTriggers }
